import { render, staticRenderFns } from "./DataViewSidebarRiskProfile.vue?vue&type=template&id=55500200&scoped=true&"
import script from "./DataViewSidebarRiskProfile.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarRiskProfile.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarRiskProfile.vue?vue&type=style&index=0&id=55500200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55500200",
  null
  
)

export default component.exports